import { useAuth } from "./use-auth";
import { RestApi } from "../rest-api";

export const useRestApi = () => {
  const { getAccessTokenSilently } = useAuth();
  const getAccessToken = () => {
    return getAccessTokenSilently({
      scope: "openid profile email",
    });
  };
  return new RestApi("/api", getAccessToken);
};
